import React from "react";
import pdfContext from "./support/PdfContext";
import QrGenerateButton from "../buttons/QrGenerateButton";

function QrCreator(props) {
    const {triggerPdfGeneration} = React.useContext(pdfContext)
    //get current url
    const url = window.location.href

    const handleClick = () => {
        triggerPdfGeneration({reportType: props.reportType, reportId: props.id, version: props.version})
    }


    return (
        <div>
            <QrGenerateButton onClick={handleClick}/>
        </div>
    )
}

export default QrCreator
